<template>
  <Dropdown
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :options="canalesDisponibles"
    optionLabel="nombre"
    optionValue="id"
    :filter="true"
    :placeholder="placeholder"
    :disabled="disabled || cargando"
    :loading="cargando"
    dataKey="id"
    class="w-full"
  />
</template>

<script>
import CanalVentaService from '@/service/CanalVentaService';

export default {
  name: 'SelectCanalVenta',
  props: {
    modelValue: {
      type: [String, Number],
      required: false
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Seleccione un Canal de Venta'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mostrarTodos: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      canalesDisponibles: [{ id: 0, nombre: "Cargando opciones..." }],
      cargando: false,
      canalVentaService: new CanalVentaService()
    }
  },
  mounted() {
    this.cargarCanales();
  },
  methods: {
    async cargarCanales() {
      this.cargando = true;
      try {
        const response = await this.canalVentaService.getCanalVentaSelect();
        console.log('=== RAW RESPONSE ===', response, 'TYPEOF:', typeof response, 'IS_ARRAY:', Array.isArray(response));
        
        // Vamos a buscar el array venga donde venga
        let canalesArray = [];
        if (Array.isArray(response)) {
          canalesArray = response;
        } else if (response && Array.isArray(response.canales_venta)) {
          canalesArray = response.canales_venta;
        } else if (response && Array.isArray(response.canalventa)) {
          canalesArray = response.canalventa;
        } else if (response && Array.isArray(response.data)) {
          canalesArray = response.data;
        } else if (response && response.data && Array.isArray(response.data.canales_venta)) {
          canalesArray = response.data.canales_venta;
        }
        
        console.log('=== DATA EXTRAIDA ===', canalesArray);

        let nuevosCanales = [];
        
        if (canalesArray.length > 0) {
          nuevosCanales = canalesArray.map(canal => {
            return {
              id: canal.id,
              nombre: canal.nombre
            };
          });
        }
        
        if (this.mostrarTodos) {
          nuevosCanales.unshift({ id: 0, nombre: "TODOS" });
        }
        
        this.canalesDisponibles = nuevosCanales;
          
          console.log('Opciones finales para el Dropdown:', this.canalesDisponibles);
          
          // Si no hay ningún canal seleccionado actualmente por el v-model, 
          // autoseleccionamos el primero de la lista por defecto.
          if (!this.modelValue && this.canalesDisponibles.length > 0) {
            this.$emit('update:modelValue', this.canalesDisponibles[0].id);
          }
      } catch (error) {
        console.error("Error cargando canales de venta para el Dropdown:", error);
      } finally {
        this.cargando = false;
      }
    }
  }
}
</script>

<style scoped>
/* Puedes agregar estilos específicos aquí si lo necesitas */
</style>
